import { SaveOutlined } from "@ant-design/icons";
import { Button, Layout, Select, Table, Tag } from "antd";
import { Content, Footer } from "antd/es/layout/layout";
import { Header, TableSearch } from "components";
import moment from "moment";
import React, { useEffect } from "react";
import { connect } from "react-redux";

import { getAllExpenses, updateAllExpenses } from "services/expense-service";
import { EXPENSE_STATUS_DATA } from "utils/static-data";

const mapStateToProps = (state) => ({
  login: state.authReducer.loginReducer,
});
const DataFetch = {
  data: [],
  loading: false,
};
export const ExpenseScreen = (props) => {
  const { login } = props;
  const [data, setData] = React.useState(DataFetch);
  const [loadingUpdate, setLoadingUpdate] = React.useState(false);
  const [initialData, setInitialData] = React.useState(DataFetch);
  const load = async () => {
    setData((prev) => ({ ...prev, loading: true }));
    const res = await getAllExpenses();
    setData((prev) => ({ ...prev, data: res, loading: false }));
    setInitialData((prev) => ({ ...prev, data: res, loading: false }));
  };

  useEffect(() => {
    load();
  }, []);
  return (
    <Layout className="alymente-layout">
      <Header title="Comprovantes de gastos" />
      <Content>
        <Table
          scroll={ { x: 1000 } }
          pagination={ false }
          dataSource={ data.data }
          loading={ data.loading }
          initialData={ initialData.data }
          bordered
          title={ () => (
            <div
              style={ {
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              } }
            >
              <TableSearch
                data={ data }
                initialData={ initialData.data }
                filter={ [
                  "transactionId",
                  "status",
                  "value",
                  "mileage",
                  "litersFuel",
                  "transactionAt",
                ] }
                onSearch={ (e) => {
                  setData((prev) => ({ ...prev, data: e }));
                } }
              />
            </div>
          ) }
        >
          <Table.Column
            width={ 150 }
            align="center"
            title="Data da Transação"
            dataIndex={ "transactionAt" }
            key="data.transactionAt"
            render={ (value) => moment(value).format("DD/MM/YYYY") }
          />
          <Table.Column
            width={ 70 }
            align="center"
            title="ID"
            dataIndex={ "transactionId" }
            key="userSex.code"
          />

          <Table.Column
            width={ 150 }
            title="Nome"
            dataIndex="name"
            key="data.name"
          />
          <Table.Column
            width={ 200 }
            align="center"
            title="Participante"
            dataIndex={ ["employee", "name"] }
            key="userSex.code"
          />
          <Table.Column
            width={ 100 }
            align="center"
            title="Status"
            dataIndex={ "status" }
            key="data.value"
            render={ (value, record) => (
              <Select
                style={ { width: "100%" } }
                value={ value }
                onChange={ (value) =>
                  setData((data) => {
                    const newData = data.data.map((item) =>
                      item.transactionId === record.transactionId
                        ? { ...item, status: value }
                        : item,
                    );
                    return { ...data, data: newData };
                  })
                }
              >
                { EXPENSE_STATUS_DATA.map((item) => (
                  <Select.Option key={ item.code } value={ item.code }>
                    <Tag
                      color={ item.category }
                      bordered={ false }
                      style={ { background: "none", fontSize: "14px" } }
                    >
                      { item.name }
                    </Tag>
                  </Select.Option>
                )) }
              </Select>
            ) }
          />
          <Table.Column
            width={ 150 }
            align="center"
            title="Segmentação"
            dataIndex={ ["benefit", "name"] }
            key="data.benefit.name"
          />
          <Table.Column
            width={ 150 }
            align="center"
            title="Valor"
            dataIndex={ "value" }
            key="data.value"
            render={ (value) =>
              `R$ ${Number(value).toFixed(2).replace(".", ",")}`
            }
          />

          <Table.Column
            width={ 100 }
            title="Quilometragem"
            dataIndex={ "mileage" }
            key="data.mileage"
            render={ (value) =>
              value ? `${Number(value).toFixed(2).replace(".", ",")} km` : ''
            }
          />
          <Table.Column
            width={ 150 }
            align="center"
            title="Litros"
            dataIndex={ "litersFuel" }
            key="data.litersFuel"
            render={ (value) =>
              value ? `${Number(value).toFixed(2).replace(".", ",")} L` : ''
            }
          />
        </Table>
      </Content>

      <Footer>
        <Button
          loading={ data.loading }
          className="btn-save"
          type="primary"
          icon={ <SaveOutlined /> }
          onClick={ async () => {
            const modifiedItem = data.data.filter((item) => {
              const initialItem = initialData.data.find(
                (initialItem) =>
                  initialItem.transactionId === item.transactionId,
              );
              return initialItem?.status !== item?.status;
            });
            if (modifiedItem.length > 0) {
              setData((prev) => ({ ...prev, loading: true }));
              await updateAllExpenses(modifiedItem);
              setData((prev) => ({ ...prev, loading: false }));
              setInitialData((prev) => ({
                ...prev,
                data: data.data,
                loading: false,
              }));
            }
          } }
        >
          Salvar
        </Button>
      </Footer>
    </Layout>
  );
};
export default connect(mapStateToProps, {})(ExpenseScreen);
